import { Component } from '@angular/core';
import { AccountState } from '@app/finxone-web-frontend/app/lib/state/account.state';
import { FormActionState } from '@app/finxone-web-frontend/app/lib/state/form-submision.state';
import { AccountInfoType } from '@finxone-platform/shared/sys-config-types';
import { Store } from '@ngxs/store';
import { FormSubmitter } from '../form-widgets/form-submitter/form-submitter.component';
@Component({
  standalone: false,
  selector: 'finxone-web-frontend-edit-beneficiary',
  templateUrl: './edit-beneficiary.component.html',
})
export class EditBeneficiaryComponent extends FormSubmitter {
  public formActionStateData: { [key: string]: string };
  public dynamicZone = true;
  public selectedAccount: AccountInfoType | undefined;
  constructor(protected override store: Store) {
    super(store);
    this.selectedAccount = this.store.selectSnapshot(AccountState.getCurrentAccount);
    this.getFormStateData();
  }

  public getFormStateData() {
    this.formActionStateData = this.store.selectSnapshot(
      FormActionState.getFormActionState,
    )?.response?.formData;
  }
}
